import React from "react";

import { Box, Card, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

import { CardSkeletonProps } from "./types";

const useStyles = (dark: boolean) =>
  makeStyles(theme => ({
    root: {
      padding: theme.spacing(3, 2),
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      maxHeight: "96px",
      backgroundColor: dark ? "#0D73D9" : theme.palette.common.white,
    },
    skeleton: {
      backgroundColor: dark ? "#B0BEC5" : "rgba(0, 0, 0, 0.04)",
    },
  }));

const CardSkeleton: React.FC<CardSkeletonProps> = ({ dark = false }) => {
  const classes = useStyles(dark)();
  return (
    <Card className={classes.root}>
      <Box flexGrow={1}>
        <Skeleton variant="text" width="50%" className={classes.skeleton} />
        <Skeleton
          variant="text"
          width="85%"
          height={32}
          className={classes.skeleton}
        />
      </Box>
      <Skeleton
        variant="circle"
        height={48}
        width={48}
        className={classes.skeleton}
      />
    </Card>
  );
};

export default CardSkeleton;
